export enum PaymentCollector {
  AIRBNB = 'airbnb',
  BOOKING = 'booking',
  PAYMOB = 'paymob',
  BIRDNEST = 'birdnest'
}
